
import { createApiClient } from 'Network/ApiClient';

export const ActivityTypeAxiosInstance = createApiClient('');


